import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-st-elements',
    templateUrl: './st-elements.component.html',
    styleUrls: ['./st-elements.component.scss'],
    standalone: false
})
export class StElementsComponent implements AfterViewInit {
  @Input() loading: boolean;
  @Input() hasBackButton = false;
  @Output() cardComplete = new EventEmitter();
  @Output() cardFilled = new EventEmitter();
  @Output() declinePayment = new EventEmitter();
  @ViewChild('cardElement') cardElement: ElementRef;
  stripe; // : stripe.Stripe;
  card;
  cardErrors;
  subscription: Subscription = new Subscription();

  confirmation;
  constructor(private translate: TranslateService) {
    this.subscription.add(this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.mountStripe(params.lang);
    }));
  }

  ngAfterViewInit() {
    const language = this.translate.currentLang;
    this.mountStripe(language);
  }

  mountStripe(language) {
    const style = {
      base: {
        color: '#14171C',
        lineHeight: '24px',
        fontSize: '16px',
        fontWeight: '600',
        fontFamily: 'Inter, system-ui, sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#667080',
        }
      }
    };

    this.stripe = Stripe(environment.stripePublishableKey, { locale: language });
    const elements = this.stripe.elements();

    this.card = elements.create('card', {style});
    this.card.mount(this.cardElement.nativeElement);

    this.card.addEventListener('change', (val) => {
      if (val.complete === true) {
        this.cardComplete.emit({brand: val.brand});
      }
      const error = val.error;
      this.cardErrors = error && error.message;
    });
  }

  decline() {
    this.declinePayment.emit();
  }

  async handleForm(e) {
    this.cardErrors = null;
    e.preventDefault();

    const { error, paymentMethod } = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.card,
    });

    if (error) {
      this.cardErrors = error.message;
    } else {
      this.cardFilled.emit(paymentMethod);
    }
  }

}
